import TemplateTab from './TemplateTab';

export default TemplateTab;
